import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const investigate849RejectionsStep = defineStepConfig({
  type: "investigate_849_rejections",
  name: "Investigate 849 Rejections",
  description:
    "Run the 849 Rejection Investigation agent on an SD849Response. " +
    "Gated by per-supplier sd_849_investigation_enabled toggle. " +
    "Skips silently if no rejections or investigation is disabled.",
  category: "AI & Agents",
  libraryModule: "ShipAndDebit",
  inputSchema: z.object({
    sd849ResponseId: z
      .string()
      .nullable()
      .describe("ID of the SD849Response to investigate (null if skipped)"),
  }),

  outputSchema: z.object({
    investigated: z.boolean().describe("Whether the investigation agent ran"),
    skippedReason: z
      .string()
      .nullable()
      .describe("Why investigation was skipped (null if it ran)"),
    summary: z
      .string()
      .nullable()
      .describe("Agent investigation summary (null if skipped)"),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "5 minutes",
    nonRetryableErrorTypes: [
      "WorkflowGuardrailBlockedError",
      "WorkflowGuardrailReviewRequiredError",
    ],
  },
});
